import { createSlice } from '@reduxjs/toolkit';
const initialCounts = {
  M: {
    'Bags': 10,
    'Belt': 10,
    'Caps & Hats': 5,
    'Coats, Suits, Blazers': 50,
    'Ethinic Wear': 40,
    'Footwear': 50,
    'Jackets': 50,
    'Jeans': 75,
    'Lounge Coords': 50,
    'Shirts': 100,
    'Shorts': 30,
    'Sunglasses': 50,
    'Sweaters & Cardigans': 60,
    'Sweatshirts & Hoodies': 75,
    'Track/ Sweat/ Pyjama Pants': 50,
    'Trousers': 75,
    'Tshirts': 100
  },
  F: {
    Topwear: 200,
    'Bags': 50,
    'Belt': 10,
    //    'Blouse': 0,
    'Caps & Hats': 5,
    'Coats, Suits, Blazers': 30,
    //    'Coords': 0,
    'Dresses': 200,
    'Dungaree': 0,
    'Ethinic Wear': 50,
    'Footwear': 50,
    'Glove': 5,
    'Jackets': 50,
    'Jeans': 50,
    'Jumpsuits': 10,
    'Leggings': 20,
    'Lingerie & Swimwear': 30,
    'Lounge Coords': 50,
    'Other Outerwear': 10,
    'Shirts': 20,
    'Shorts': 10,
    'Skirts': 50,
    'Skorts': 0,
    'Socks & Stockings': 10,
    'Sunglasses': 30,
    'Sweaters & Cardigans': 100,
    'Sweatshirts & Hoodies': 50,
    //    'Swim wear': 0,
    'Track/ Sweat/ Pyjama Pants': 50,
    'Trousers': 60,
    'Tshirts': 50,

  },
}
const styleProcudeCounts = createSlice({
  name: "styleProcudeCounts",
  initialState: initialCounts,
  reducers: {
    updateCategoryCount: (state, param) => {
      state[param.payload.gender][param.payload.category] = param.payload.count
    },
  }
});


const { actions, reducer } = styleProcudeCounts
export const { updateCategoryCount } = actions;
export default reducer;
